"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CustomProjectCTA() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="customprojectcta" className="bg-background px-6 py-16 md:py-24 lg:px-8">
      <div ref={ref} className={`mx-auto max-w-4xl rounded-2xl border-t-4 border-primary bg-secondary px-6 py-16 text-center shadow-2xl transition-all duration-700 ease-out sm:px-12 sm:py-20 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <h2 className="font-default text-3xl font-bold tracking-tight text-white sm:text-4xl">
          {"Get a Quote on Custom Acrylic Signs and Cutting"}
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-white/80">
          {"Upload your file or describe your project — size, material, color, quantity, and mounting. Evermark Industrial returns a quote and digital proof same business day. No minimums. US production."}
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button asChild size="lg" className="w-full sm:w-auto">
            <Link to="#">
              {"Request a Quote"}
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white sm:w-auto">
            
          </Button>
        </div>
      </div>
    </section>;
}